import React from 'react';
import OperationRoomTabletV2 from './v2/OperationRoomTabletV2';
import OperationRoomTabletV1 from './OperationRoomTabletV1';
import { useScope } from '@/hooks/useScope';

const OperationRoomTablet = (props: any) => {
  const scope = useScope();
  const isScopeLoaded = scope;
  const useOrTabletV2 = scope?.hospital?.modules?.orTabletV2 ?? true;
  return isScopeLoaded ? (
    useOrTabletV2 ? (
      <OperationRoomTabletV2 {...props} />
    ) : (
      <OperationRoomTabletV1 {...props} />
    )
  ) : null;
};

export default OperationRoomTablet;
